import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RankingView from '../views/RankingView.vue'
import ContactView from '../views/ContactView.vue'
import FranchiseView from '../views/FranchiseView.vue'
import LoginView from '../views/LoginView.vue'
import About from '../views/About.vue'
import Legal from '../views/Legal.vue'
import EventsView from '../views/EventsView.vue'
import BookingView from '../views/BookingView.vue'
import LocationView from '../views/LocationView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: RankingView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/franchise',
    name: 'franchise',
    component: FranchiseView
  },
  {
    path: '/login',
    name: 'login',
    beforeEnter: (to, from, next) => {
      window.location.replace("https://app.spark81.com/login")
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/legal',
    name: 'legal',
    component: Legal
  },
  {
    path: '/events',
    name: 'events',
    component: EventsView
  },
  {
    path: '/booking',
    name: 'booking',
    component: BookingView
  },
  {
    path: '/barcelona',
    name: 'barcelona',
    component: LocationView,
    //IMAGE MUST BE IN PUBLIC FOLDER
    props: {
      heroTitle: "SPARK81 Barcelona",
      heroSubtitle: "Vive la mejor experiencia de acción arcade en la ciudad",
      sectionTitle: "SPARK81 Barcelona",
      sectionDescription: "Ubicado entre Poblenou y Sant Martí, nuestro centro cuenta con 7 salas de juego y un amplio hall ideal para celebraciones y eventos.",
      additionalInfo: "El centro se encuentra cerca del distrito tecnológico 22@, rodeado de una vibrante comunidad de innovación y entretenimiento. Un punto de encuentro para gamers, aventureros y equipos en busca de retos épicos.",
      eventsDescription: "Nuestro hall permite organizar eventos para grupos grandes de hasta 40 participantes, desde cumpleaños hasta team buildings y celebraciones privadas. Contamos con servicio de snacks y bebidas.",
      cumpleanosDescription: "Pack para grupos de mínimo <b>10 participantes</b> (repartidos en equipos de 6). Incluye <b>juego en 4 salas (1h 20 min)</b>, merienda con bocadillo y <b>30 min de mesa reservada para la celebración</b>. Si sois menos, se cobra igualmente el mínimo. <b>Precios por participante:</b>",
      eventoPrivadoDescription: "Pack para grupos de mínimo <b>20 participantes</b>. Incluye acceso ilimitado a las salas, reserva exclusiva del espacio y un botellín de agua por persona. Ideal para team buildings, afterworks y celebraciones privadas. <b>Reserva por email</b> y sujeta a disponibilidad. Se aplica el mínimo de <b>20 personas</b> aunque el grupo sea menor. Precio por participante (<b>IVA no incluido</b>).",
      address: "Gran Via de les Corts Catalanes 1122, Barcelona",
      locationLink: "https://g.co/kgs/B1QLCLX",
      email: "barcelona@spark81.com",
      phone: "+34 644255104",
      busLines: "H12, V29",
      busStop: "",
      metroStation: "Besós (L4) y Sant Martí (L2)",
      tramStation: "Sant Martí de Provençals",
      parkingInfo: "Plazas en zona verde cercanas",
      mondaySchedule: "",
      tuesdaythursdaySchedule: "16:00 - 22:00",
      fridaySchedule: "16:00 - 22:00",
      saturdaySchedule: "10:00 - 23:00",
      sundaySchedule: "10:00 - 23:00",
      rooms: "mosaicox2, botones, dianas, gaming, radar, jungla",
      images: [
        "LocalBCN (2).jpeg",
        "LocalBCN (1).jpeg",
        "LocalBCN (3).jpeg"
      ],
      instagram: "https://instagram.com/spark81.barcelona",
      tiktok: "",
      pricingType: "A",
      pricingHeaders: {
        desktop: [
          "Jugadores",
          "Mar-Jue<br />3 salas<br/>1h",
          "Mar-Jue<br />5 salas<br/>1h 40 min",
          "Viernes<br/>Finde<br/>festivos<br/>3 salas<br/>1h",
          "Viernes<br/>Finde<br/>festivos<br />5 salas<br/>1h 40min"
        ],
        mobile: {
          titlesemana: "Martes a Jueves:",
          titlefinde: "Viernes, findes y festivos:",
          entreSemana: ["Jugadores", "3 salas<br/>1h", "5 salas<br/>1h 40 min"],
          findeFestivos: ["Jugadores", "3 salas<br/>1h", "5 salas<br/>1h 40 min"]
        }
      },
      pricing: {
        entreSemana: {
          "3salas": {
            "2": { old: 28, new: 26 },
            "3": { old: 25, new: 23 },
            "4": { old: 22, new: 20 },
            "5": { old: 20, new: 18 },
            "6+": { old: 19, new: 17 }
          },
          "5salas": {
            "2": { old: 35, new: 28 },
            "3": { old: 32, new: 25 },
            "4": { old: 28, new: 22 },
            "5": { old: 26, new: 20 },
            "6+": { old: 24, new: 19 }
          }
        },
        findeFestivos: {
          "3creditos": {
            "2": 28,
            "3": 25,
            "4": 22,
            "5": 20,
            "6+": 19
          },
          "5creditos": {
            "2": 35,
            "3": 32,
            "4": 28,
            "5": 26,
            "6+": 24
          }
        },

        cumpleanos: {
          finde:1,
          menus: {
            Cumpleaños : {
              entreSemana: 25,
              finde: 30
            },
          }
        },
        eventoPrivado: {
          "2h": {
            precio: 30,
          },
          horaExtra: {
            precio: 10,
          },
          mediaManana: {
            duracion: "4 horas",
            precio: 40,
          }
        }
      }

    },
  },
  {
    path: '/coruna',
    name: 'coruna',
    component: LocationView,
    props: {

      heroTitle: "SPARK81 A Coruña",
      heroSubtitle: "Vive la mejor experiencia de acción arcade de Galicia",
      sectionTitle: "SPARK81 A Coruña",
      sectionDescription: "Ubicado frente a la playa de Riazor, nuestro centro cuenta con 7 salas de juego, perfectas para desafiar tus habilidades y divertirte con amigos.",
      additionalInfo: "Un espacio diseñado para desafiarte a otro nivel. Este centro combina la intensidad del juego con la estética gamer para una experiencia inmersiva única.",
      cumpleanosDescription: "Pack para grupos de mínimo <b>10 participantes</b> (repartidos en equipos de 6). Incluye <b>juego en 4 salas (1h 20 min)</b> y merienda <b>(30 min de mesa reservada para la celebración)</b>. Si sois menos, se cobra igualmente el mínimo. Se puede elegir entre dos opciones de menú:<br><br><b>Menú BASIC</b>, que incluye sándwich de jamón, de queso y de nocilla, chocolatina, bolsa de snack salado, bebidas (agua o refrescos), y tarta o helado.<br><br><b>Menú PREMIUM</b>, que incluye pizza casera de jamón y queso y hot dogs, chocolatina, bolsa de snack salado, bebidas (agua o refrescos), y tarta y helado.<br><br><b>Precios por participante:</b>",
      eventoPrivadoDescription: "Pack para grupos de mínimo <b>20 participantes</b>. Incluye acceso ilimitado a las salas, reserva exclusiva del espacio y un botellín de agua por persona. Ideal para team buildings, afterworks y celebraciones privadas. <b>Reserva por email</b> y sujeta a disponibilidad. Se aplica el mínimo de <b>20 personas</b> aunque el grupo sea menor. Precio por participante (<b>IVA no incluido</b>).",
      eventsDescription: "Organizamos eventos para todas las edades, desde cumpleaños hasta team buildings. Además, ofrecemos opciones de snacks y bebidas para completar la experiencia.",
      address: "Calle Riazor 8, A Coruña",
      locationLink: "https://g.co/kgs/s5pHbUL",
      email: "info@spark81coruna.com",
      phone: "+34 633586858",
      busLines: "",
      busStop: "Playa de Riazor",
      metroStation: "",
      tramStation: "",
      parkingInfo: "",
      mondaySchedule: "",
      tuesdaythursdaySchedule: "16:00 - 21:00",
      fridaySchedule: "16:00 - 21:00",
      saturdaySchedule: "11:00 - 14:00 y 16:00 - 21:00",
      sundaySchedule: "11:00 - 14:00 y 16:00 - 21:00",
      rooms: "mosaicox2, botones, dianas, gaming, radar, jungla",
      // IMAGE MUST BE IN PUBLIC FOLDER
      images: [
        "Local_Coruna3.jpg",
        "Local_Coruna2.jpg",
        "Local_Coruna1.jpg"
      ],
      instagram: "https://instagram.com/spark81coruna",
      tiktok: "https://tiktok.com/@spark81coruna",
      pricingType: "A",
      pricingHeaders: {
        desktop: [
          "Jugadores",
          "Mar-Jue<br />3 salas<br/>1h",
          "Mar-Jue<br />5 salas<br/>1h 40 min",
          "Viernes<br/>Finde<br/>festivos<br/>3 salas<br/>1h",
          "Viernes<br/>Finde<br/>festivos<br />5 salas<br/>1h 40min"
        ],
        mobile: {
          titlesemana: "Martes a Jueves:",
          titlefinde: "Viernes, findes y festivos:",
          entreSemana: ["Jugadores", "3 salas<br/>1h", "5 salas<br/>1h 40 min"],
          findeFestivos: ["Jugadores", "3 salas<br/>1h", "5 salas<br/>1h 40 min"]
        }
      },
      pricing: {
        entreSemana: {
          "3salas": {
            "2": { old: 28, new: 26 },
            "3": { old: 25, new: 23 },
            "4": { old: 22, new: 20 },
            "5": { old: 20, new: 18 },
            "6+": { old: 19, new: 17 }
          },
          "5salas": {
            "2": { old: 35, new: 28 },
            "3": { old: 32, new: 25 },
            "4": { old: 28, new: 22 },
            "5": { old: 26, new: 20 },
            "6+": { old: 24, new: 19 }
          }
        },
        findeFestivos: {
          "3creditos": {
            "2": 28,
            "3": 25,
            "4": 22,
            "5": 20,
            "6+": 19
          },
          "5creditos": {
            "2": 35,
            "3": 32,
            "4": 28,
            "5": 26,
            "6+": 24
          }
        },

        cumpleanos: {
          finde:0,
          menus: {
            BASIC: {
              entreSemana: 25,
              finde: 0
            },
            PREMIUM: {
              entreSemana: 30,
              finde: 0
            }
          }
        },
        eventoPrivado: {
          "2h": {
            precio: 30,
          },
          horaExtra: {
            precio: 10,
          },
          mediaManana: {
            duracion: "4 horas",
            precio: 40,
          }
        }
      }
    }
  },
  {
    path: '/terrassa',
    name: 'terrassa',
    component: LocationView,
    props: {
      heroTitle: "SPARK81 Terrassa - La Lanzadera",
      heroSubtitle: "Vive la mejor experiencia de acción arcade del Vallès",
      sectionTitle: "SPARK81 Terrassa - La Lanzadera",
      sectionDescription: "Situado al lado del Parc Vallès, nuestro centro cuenta con 4 salas de juego, una recepción y una sala extra para celebraciones.",
      additionalInfo: "El centro se encuentra dentro del complejo The City Escape Room, junto a experiencias de escape room y realidad virtual.",
      eventsDescription: "En SPARK81 Terrassa puedes celebrar cumpleaños, despedidas, eventos de empresa y mucho más en una sala equipada para grupos de hasta 30 personas; puedes reservar media sala (hasta 8 personas) por 50 €/hora o la sala completa por 100 €/hora, con acceso al rincón gaming y opción de añadir bebida y snack por 3 € por persona.",
      address: "Carrer del Llobregat, 4B, Local 11, Terrassa (en The City Escape Room)",
      locationLink: "https://g.co/kgs/pm1RabG",
      email: "barcelona@thecityescaperoom.com",
      phone: "+34 682289441",
      busLines: "3, 6, 9",
      busStop: "Parc Vallès",
      trainStation: "Terrassa Estació del Nord",
      tramStation: "",
      parkingInfo: "Parking gratuito en Parc Vallès",
      mondaySchedule: "16:00 - 22:00",
      tuesdaythursdaySchedule: "16:00 - 22:00",
      fridaySchedule: "16:00 - 22:00",
      saturdaySchedule: "10:00 - 23:00",
      sundaySchedule: "10:00 - 23:00",
      rooms: "mosaico, botones, dianas, gaming",
      // IMAGE MUST BE IN PUBLIC FOLDER
      images: [
        "LocalTER (1).jpg",
        "LocalTER (2).jpg",
        "LocalTER (3).jpg"
      ],
      instagram: "https://instagram.com/thecity_bcn",
      tiktok: "",
      pricingType: "B",
      pricing: [
        { nom: "2", descripcio: "", preu: "30 €" },
        { nom: "3", descripcio: "", preu: "23 €" },
        { nom: "4", descripcio: "", preu: "21 €" },
        { nom: "5", descripcio: "", preu: "20 €" },
        { nom: "6 o más", descripcio: "", preu: "18 €" }
      ],
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
